/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.directive('logtime', () => ({
    restrict:    'E',
    templateUrl: 'directives/widget/log_time/template.html',
    controller:  'LogTimeCtrl',
    replace:     true,

    scope: {
        login: '@'
    }
}));
